<template>
  <main class="loan-list">
    <div class="control-page-common content-wrapper">
      <el-row class="title title-border title-flex">
        <div>采购宝</div>
        <el-common-video></el-common-video>
      </el-row>
      <section class="loan-top">
        <p class="loan-head">
          <span class="loan-title">我要借钱</span
          ><span class="loan-momeny"
            >总额度{{ $utils.toYuan(customer.creditMny) }}元</span
          >
        </p>
        <div class="loan-total-momeny">
          <section class="loan-total-top">
            <p class="quota" v-if="customer.creditStatus === 2">可借额度(元)</p>
            <p class="momeny" v-if="customer.creditStatus === 2">
              {{ $utils.fenToWan(customer.creditBalance) }}
              <span class="unit">万</span>
            </p>
            <p class="no-quota" v-if="customer.creditStatus !== 2">
              暂无可借额度
            </p>
            <p class="loan-info">
              <span>日费率0.433‰</span> <span>随时可借 次日可还</span>
              <span>提前还款无手续费</span>
            </p>
          </section>
          <p class="loan-btn" @click="toBorrow">去借钱</p>
        </div>
      </section>
      <section class="loan-list-wrapper loan-top">
        <p class="loan-head"><span class="loan-title">申请中的借款</span></p>
        <order-list />
      </section>
    </div>
    <div class="side">
      <section class="bond">
        <div class="unsign-bond" v-if="creditResult.depositPayStatus == 2">
          <p class="bond-top"><span class="bond-name">保证金</span></p>
          <div class="unpaid">
            <!--保证金未缴纳-->
            <p class="unpaid-info">借款前需缴纳保证金;</p>
            <p class="unpaid-info">保证金的缴纳金额为实际借款额的5%</p>
            <p class="unpaid-info-small">
              例如:申请50万借款，需缴纳2.5万的保证金
            </p>
            <p class="tooltip-wrapper">
              <span class="bond-btn" @click="openBondDialog">缴纳保证金</span>
              <span
                class="tooltip"
                v-if="creditResult.depositPayStatus == 2 && showFlag"
                >借钱请先缴纳保证金<img
                  @click="close"
                  class="close"
                  src="../../../assets/images/orange-loan/close.svg"
                  alt=""
              /></span>
            </p>
          </div>
        </div>
        <div class="signed-bond" v-else>
          <p class="bond-top">
            <span class="bond-name">保证金</span>
            <span v-if="creditResult.depositContractStatus == 1"
              ><a
                class="check-btn"
                :href="creditResult.depositContractUrl"
                target="_blank"
                >查看合同</a
              ></span
            >
          </p>
          <div
            class="bond-content"
            v-if="creditResult.depositContractStatus == 1"
          >
            <!--保证金生效-->
            <p class="img-wrapper">
              <img
                src="../../../assets/images/orange-loan/default-end.png"
                alt=""
              />
            </p>
            <p class="bond-moneny">
              已缴纳保证金 ￥{{ $utils.toYuan(customer.depositAmount) }}
            </p>
            <p class="refund-moneny">
              冻结￥{{ $utils.toYuan(customer.depositPaidMny) }} | 可退 ￥{{
                $utils.toYuan(customer.depositMaxMny)
              }}
            </p>
            <p class="bond-info">*如需缴纳/变更/退保证金请联系客户经理</p>
          </div>
          <div
            class="unSigned"
            v-if="creditResult.depositContractStatus !== 1"
            :class="{ signing: creditResult.depositContractStatus == 3 }"
          >
            <!--合同未签署或者签署中状态还没给-->
            <p class="sign-contract">交纳保证金需要您签署合同!</p>
            <p>
              <a
                class="contract-name"
                :href="creditResult.depositContractUrl"
                target="_blank"
                >《最高额质押担保合同》</a
              >
            </p>
            <span
              class="bond-btn"
              v-if="creditResult.depositContractStatus == 2"
              @click="signContract(creditResult.depositContractId)"
              >同意并签署合同</span
            >
            <!--合同未签署展示-->
            <span
              class="bond-btn"
              v-if="creditResult.depositContractStatus == 3"
              >合同签署中</span
            >
            <!--签署中展示-->
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import orderList from './order-list.vue'
import commonVideo from '../../console-common/common-video.vue'
import { mapState } from 'vuex'
export default {
  created() {
    this.getCustomerInfo()
    this.$emit('to-loan-launch', {
      status: 0,
    })
  },
  components: {
    orderList,
    'el-common-video': commonVideo,
  },
  data() {
    return {
      showFlag: true,
    }
  },
  computed: {
    ...mapState('loan', ['customer', 'creditResult']),
  },
  methods: {
    openBondDialog() {
      this.$confirm('', '', {
        message: `<p class="title">缴纳保证金</p><p class="text">请联系您的客户经理  ${
          this.customer.customerManager
        } ${this.customer.customerManagerPhone}</p>`,
        dangerouslyUseHTMLString: true,
        distinguishCancelAndClose: false,
        showCancelButton: false,
        showClose: false,
        confirmButtonText: '知道了',
        type: 'warning',
      })
        .then(() => {})
        .catch((action) => {
          next()
        })
    },
    signContract(depositContractId) {
      this.$request({
        url: '/proxy/oneCar/api/deposit/sign',
        method: 'post',
        data: {
          depositContractId,
        },
      }).then((res) => {
        if (!res.errorCode) {
          this.$message({
            message: '合同签署申请已发送!',
            type: 'success',
          })
          this.$store.dispatch('loan/GET_CREDIT_QUERY', {
            // applyOrderId: 'DD0001108956186799886338'
          })
        } else {
          this.$message.error('抱歉,操作失败,请重试')
        }
      })
    },
    getCustomerInfo() {
      this.$store.dispatch('loan/GET_CUSTOMER_INFO')
      this.$store.dispatch('loan/GET_CREDIT_QUERY')
    },
    toBorrow() {
      if (this.creditResult.depositPayStatus === 2) {
        this.openBondDialog()
      } else {
        this.$router.push({ path: '/console/orange-loan/borrow/apply' })
      }
      // this.$router.push({name: 'orangeLoanApply'})
    },
    close() {
      this.showFlag = false
    },
  },
}
</script>

<style lang="stylus">
@import '../../../assets/css/common-color.styl'
.loan-list
  display flex
  justify-content space-between
  background #ebedf1
  .content-wrapper
    width 66%
    .loan-top
      padding-left 24px
      .loan-head
        margin-top 40px
        .loan-title
          font-size 16px
          padding-left 14px
          font-family PingFangSC-Medium
        &:before
          content: ''
          display inline-block
          width 2px
          height 14px
          background-color primary-color
        .loan-momeny
          font-size 14px
          color gray02
          float right
      .loan-total-momeny
        margin 20px 0 60px 0
        padding 38px 52px
        border 1px solid #F0F0F0
        box-shadow 0 4px 12px 1px rgba(226,228,234,0.29)
        border-radius 2px
        display flex
        justify-content space-around
        align-items center
        .loan-btn
          width 120px
          height 44px
          background: linear-gradient(left, #72B9FF, #2F89FD)
          box-shadow 1px 1px 1px #5591FA
          color white
          border-radius 30px
          text-align center
          line-height 44px
          cursor pointer
        .no-quota
          font-size 32px
          color gray01
          margin-bottom 12px
        .loan-total-top
          text-align center
          .momeny
            font-size 38px
            color gray01
            font-family DINPro
            margin-bottom 15px
          .quota
            font-size 14px
            color gray02
          .unit
            font-size 24px
            font-family PingFangSC-Medium
            position relative
            left -4px
            top -3px
          .loan-info
            span
              padding 6px
              margin-right 8px
              border 1px solid #D2A933
              font-size 12px
              color #D2A933
  .side
    position relative
    // top -118px
    // right -328px
    // padding-left 20px
    // height 100vh
    // padding-left 2%
    padding-left 20px
    width 30%
    background #ebedf1
    .bond
      padding 24px
      border-radius 2px
      box-shadow 0 2px 13px 8px rgba(240,240,240,0.50)
      background #FFF
      .bond-top
        display flex
        justify-content space-between
        align-items center
        margin-bottom 32px
        .bond-name
          color gray01
          font-size 18px
          font-family PingFangSC-Medium
        .check-btn
          display block
          color primary-color
          font-size 14px
          text-decoration none
      .bond-content
        display flex
        justify-content center
        flex-direction column
        align-items center
        .img-wrapper
          width 70px
          height 80px
          img
            width 100%
        .bond-moneny
          font-size 18px
          color gray01
        .refund-moneny
          font-size 14px
          color gray03
          margin 10px 0 24px 0
        .bond-info
          color gray04
          font-size 12px
      .unpaid
        .unpaid-info
          font-size 14px
          color gray02
          line-height 20px
        .unpaid-info-small
          color gray03
          font-size 12px
          margin 8px 0 22px 0
        .tooltip-wrapper
          position relative
          .tooltip
            background rgba(65,72,93,0.77)
            box-shadow 1px 1px 1px
            width 154px
            font-size 14px
            color white
            position absolute
            top 135%
            left -7%
            padding 12px 24px 12px 12px
            text-align center
            box-shadow 0 5px 20px 0 gray05
            border-radius 2px
            &:after
              content ''
              position absolute
              width 0
              height 0
              border-width 0 6px 6px
              border-style solid
              border-color transparent transparent rgba(65,72,93,0.77)
              margin 40px auto
              top -46px
              left 46%
          .close
            display block
            width 12px
            height 12px
            position absolute
            top 37%
            right 16px
            cursor pointer
        .item
          .alert-info
            color white
            font-size 14px
      .bond-btn
        display block
        width 120px
        border 1px solid primary-color
        background white
        color primary-color
        height 36px
        line-height 36px
        text-align center
        border-radius 4px
        font-size 14px
        cursor pointer
      .unSigned
        .sign-contract
          font-size 18px
          color gray02
          margin-bottom  16px
        .contract-name
          display block
          font-size 14px
          margin-bottom 32px
          text-decoration none
          color link-color
      .signing
        .bond-btn
          border 1px solid gray05
          color gray05
</style>
